import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { ThemeProvider, createTheme } from '@mui/material';
import { ToastProvider } from './context/ToastContext';
import './index.css';

// Create a theme instance (you can customize this based on your needs)
const theme = createTheme({
  // Add your theme customizations here if needed
  palette: {
    primary: {
      main: '#1976d2', // Default MUI blue, adjust as needed
    },
    // You can add more color overrides here
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);